import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c45c786c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container invoice-container"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-4" }
const _hoisted_7 = { class: "mb-1 text-bold" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["textContent"]
const _hoisted_10 = { class: "mb-0" }
const _hoisted_11 = ["textContent"]
const _hoisted_12 = ["textContent"]
const _hoisted_13 = ["textContent"]
const _hoisted_14 = { class: "mt-2" }
const _hoisted_15 = { class: "mb-1 text-bold" }
const _hoisted_16 = { class: "col-4" }
const _hoisted_17 = { class: "mb-1 text-bold" }
const _hoisted_18 = ["textContent"]
const _hoisted_19 = { class: "mb-0" }
const _hoisted_20 = ["textContent"]
const _hoisted_21 = ["textContent"]
const _hoisted_22 = ["textContent"]
const _hoisted_23 = { class: "mb-1 text-bold" }
const _hoisted_24 = ["textContent"]
const _hoisted_25 = ["textContent"]
const _hoisted_26 = { class: "mb-0" }
const _hoisted_27 = ["textContent"]
const _hoisted_28 = ["textContent"]
const _hoisted_29 = ["textContent"]
const _hoisted_30 = { class: "mt-2" }
const _hoisted_31 = { class: "mb-1 text-bold" }
const _hoisted_32 = { class: "col-4 ml-auto" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", { height: "70" }, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#cadac-group-logo" })
], -1))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = ["textContent"]
const _hoisted_36 = ["textContent"]
const _hoisted_37 = ["textContent"]
const _hoisted_38 = { class: "mb-0 text-nowrap" }
const _hoisted_39 = { class: "mr-1" }
const _hoisted_40 = { class: "mb-0 text-nowrap" }
const _hoisted_41 = { class: "mr-1" }
const _hoisted_42 = { class: "mb-0 text-nowrap" }
const _hoisted_43 = { class: "mr-1" }
const _hoisted_44 = { class: "mb-0 text-nowrap" }
const _hoisted_45 = { class: "mr-1" }
const _hoisted_46 = { class: "row" }
const _hoisted_47 = { class: "col-12" }
const _hoisted_48 = { class: "row print-footer" }
const _hoisted_49 = { class: "col-8 ml-auto pr-2 mt-3 mb-4" }
const _hoisted_50 = { class: "col-6 print-bottom" }
const _hoisted_51 = { class: "border border-primary px-2 pt-2 pb-0 mt-2" }
const _hoisted_52 = { key: 0 }
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "my-0" }, null, -1))
const _hoisted_54 = { class: "questions-block" }
const _hoisted_55 = { class: "text-primary text-bold mb-1 mt-2" }
const _hoisted_56 = { class: "d-flex align-items-end" }
const _hoisted_57 = { class: "mb-1" }
const _hoisted_58 = ["href"]
const _hoisted_59 = { class: "col-5 ml-auto pr-2 mt-2 print-bottom" }
const _hoisted_60 = { class: "mb-0 text-preline" }
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"200px"} }, null, -1))
const _hoisted_62 = { class: "mb-0" }
const _hoisted_63 = { class: "mb-0" }
const _hoisted_64 = {
  key: 1,
  class: "row"
}
const _hoisted_65 = { class: "col-12" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  class: "print-top-right",
  height: "75"
}, [
  /*#__PURE__*/_createElementVNode("use", { "xlink:href": "#cadacstore-logo" })
], -1))
const _hoisted_67 = { class: "col-8 ml-auto pr-2 mt-2 print-footer" }
const _hoisted_68 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CartOverview = _resolveComponent("CartOverview")!
  const _component_PriceSummary = _resolveComponent("PriceSummary")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_ctx.isInvoice)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("common.invoice")), 1),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("p", _hoisted_7, _toDisplayString(_ctx.$t("cart.lblShippingAddress")), 1),
                _createElementVNode("p", {
                  class: "mb-0",
                  textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.companyName)
                }, null, 8, _hoisted_8),
                _createElementVNode("p", {
                  class: "mb-0",
                  textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.street)
                }, null, 8, _hoisted_9),
                _createElementVNode("p", _hoisted_10, [
                  _createElementVNode("span", {
                    textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.postalCode)
                  }, null, 8, _hoisted_11),
                  _createElementVNode("span", {
                    class: "ml-1",
                    textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.city)
                  }, null, 8, _hoisted_12)
                ]),
                _createElementVNode("p", {
                  class: "mb-0",
                  textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.country)
                }, null, 8, _hoisted_13),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t("cart.lblContactPerson")), 1),
                  _createElementVNode("p", null, _toDisplayString(`${_ctx.checkoutForm?.personalForm?.firstName} ${_ctx.checkoutForm?.personalForm?.lastName}`), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_16, [
                (_ctx.checkoutForm?.billingAddressForm && _ctx.checkoutForm?.useDifferentInvoiceAddress)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$t("cart.lblBillingAddress")), 1),
                      _createElementVNode("p", {
                        class: "mb-0",
                        textContent: _toDisplayString(_ctx.checkoutForm?.billingAddressForm?.street)
                      }, null, 8, _hoisted_18),
                      _createElementVNode("p", _hoisted_19, [
                        _createElementVNode("span", {
                          textContent: _toDisplayString(_ctx.checkoutForm?.billingAddressForm?.postalCode)
                        }, null, 8, _hoisted_20),
                        _createElementVNode("span", {
                          class: "ml-1",
                          textContent: _toDisplayString(_ctx.checkoutForm?.billingAddressForm?.city)
                        }, null, 8, _hoisted_21)
                      ]),
                      _createElementVNode("p", {
                        class: "mb-0",
                        textContent: _toDisplayString(_ctx.checkoutForm?.billingAddressForm?.countryCode)
                      }, null, 8, _hoisted_22)
                    ], 64))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                      _createElementVNode("p", _hoisted_23, _toDisplayString(_ctx.$t("cart.lblBillingAddress")), 1),
                      _createElementVNode("p", {
                        class: "mb-0",
                        textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.companyName)
                      }, null, 8, _hoisted_24),
                      _createElementVNode("p", {
                        class: "mb-0",
                        textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.street)
                      }, null, 8, _hoisted_25),
                      _createElementVNode("p", _hoisted_26, [
                        _createElementVNode("span", {
                          textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.postalCode)
                        }, null, 8, _hoisted_27),
                        _createElementVNode("span", {
                          class: "ml-1",
                          textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.city)
                        }, null, 8, _hoisted_28)
                      ]),
                      _createElementVNode("p", {
                        class: "mb-0",
                        textContent: _toDisplayString(_ctx.checkoutForm?.companyForm?.country)
                      }, null, 8, _hoisted_29)
                    ], 64)),
                _createElementVNode("div", _hoisted_30, [
                  _createElementVNode("p", _hoisted_31, _toDisplayString(_ctx.$t("cart.lblPaymentCondition")), 1),
                  _createElementVNode("p", null, _toDisplayString(_ctx.$t(
										`checkout.paymentMethod.paymentCondition.${_ctx.checkoutForm.invoicePaymentConditionCode}`
									)), 1)
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_32, [
            _hoisted_33,
            (_ctx.checkoutForm?.cadacCompanyInfo)
              ? (_openBlock(), _createElementBlock("div", _hoisted_34, [
                  _createElementVNode("p", {
                    class: "mb-0",
                    textContent: _toDisplayString(_ctx.checkoutForm?.cadacCompanyInfo?.name)
                  }, null, 8, _hoisted_35),
                  _createElementVNode("p", {
                    class: "mb-0 text-preline",
                    textContent: _toDisplayString(_ctx.checkoutForm?.cadacCompanyInfo?.formattedAddress)
                  }, null, 8, _hoisted_36),
                  _createElementVNode("p", {
                    class: "mb-2",
                    textContent: _toDisplayString(_ctx.checkoutForm?.cadacCompanyInfo?.phoneNumber)
                  }, null, 8, _hoisted_37),
                  _createElementVNode("p", _hoisted_38, [
                    _createElementVNode("span", _hoisted_39, _toDisplayString(_ctx.$t("common.forms.lblCocNumber")) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.checkoutForm?.cadacCompanyInfo?.cocNumber), 1)
                  ]),
                  _createElementVNode("p", _hoisted_40, [
                    _createElementVNode("span", _hoisted_41, _toDisplayString(_ctx.$t("common.forms.lblVatNumber")) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.checkoutForm?.cadacCompanyInfo?.vatNumber), 1)
                  ]),
                  _createElementVNode("p", _hoisted_42, [
                    _createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t("common.forms.lblIban")) + ":", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.checkoutForm?.cadacCompanyInfo?.iban), 1)
                  ]),
                  _createElementVNode("p", _hoisted_44, [
                    _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.$t("common.forms.lblBic")) + ": ", 1),
                    _createElementVNode("span", null, _toDisplayString(_ctx.checkoutForm?.cadacCompanyInfo?.bic), 1)
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_46, [
          _createElementVNode("div", _hoisted_47, [
            _createVNode(_component_CartOverview, {
              "cart-client": _ctx.cartClient,
              "is-editable": false
            }, null, 8, ["cart-client"])
          ])
        ]),
        _createElementVNode("div", _hoisted_48, [
          _createElementVNode("div", _hoisted_49, [
            _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"]),
            _createElementVNode("small", null, _toDisplayString(_ctx.$t("cart.lblPrintDisclaimer")), 1)
          ]),
          _createElementVNode("div", _hoisted_50, [
            _createElementVNode("div", _hoisted_51, [
              (_ctx.cartClient?.totalWalletAmountEarned)
                ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                    _createElementVNode("p", null, [
                      _createVNode(_component_i18n_t, { keypath: "cart.lblWalletAmountEarned" }, {
                        default: _withCtx(() => [
                          _createElementVNode("b", null, _toDisplayString(_ctx.formatCurrency(_ctx.cartClient?.totalWalletAmountEarned)), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _hoisted_53
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_54, [
                _createElementVNode("h4", _hoisted_55, _toDisplayString(_ctx.$t("common.support.anyQuestions")), 1),
                _createElementVNode("div", _hoisted_56, [
                  _createElementVNode("small", _hoisted_57, [
                    _createVNode(_component_i18n_t, { keypath: "common.support.contactUsAt" }, {
                      default: _withCtx(() => [
                        _createElementVNode("a", {
                          href: 'tel:' + _ctx.$t('common.support.phoneNumber')
                        }, _toDisplayString(_ctx.$t("common.support.phoneNumber")), 9, _hoisted_58)
                      ]),
                      _: 1
                    })
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("p", _hoisted_60, _toDisplayString(_ctx.$t("cart.lblPrintSignature")), 1),
            _hoisted_61,
            _createElementVNode("p", _hoisted_62, _toDisplayString(`${_ctx.checkoutForm?.personalForm?.firstName} ${_ctx.checkoutForm?.personalForm?.lastName}`), 1),
            _createElementVNode("p", _hoisted_63, _toDisplayString(_ctx.checkoutForm?.companyForm?.companyName), 1)
          ])
        ])
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_64, [
        _createElementVNode("div", _hoisted_65, [
          _hoisted_66,
          _createElementVNode("h1", null, _toDisplayString(_ctx.title), 1),
          _createVNode(_component_CartOverview, {
            "cart-client": _ctx.cartClient,
            "is-editable": false
          }, null, 8, ["cart-client"]),
          _createElementVNode("div", _hoisted_67, [
            _hoisted_68,
            _createVNode(_component_PriceSummary, { vm: _ctx.priceSummary }, null, 8, ["vm"]),
            _createElementVNode("small", null, _toDisplayString(_ctx.$t("cart.lblPrintDisclaimer")), 1)
          ])
        ])
      ]))
}